import React from 'react';
import Wrapper from '../assets/wrappers/Footer';

const Footer = () => {
  return (
    <Wrapper>
        <p><span>Coded</span> by <span>Russell Ramiro</span> ©2023</p>
        <a href='https://github.com/r4sy4n/portfolio' target='_blank'><strong>Source Code</strong></a>
    </Wrapper>
  )
}

export default Footer;